import { Menu, MenuList, MenuItem, MenuButton, IconButton, useDisclosure } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';
import { ConfirmationModal } from 'shared-components';
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";

interface IProps {
  onCSVDownload: () => void;
  onRegenerateScores: () => void;
  isProcessing: boolean;
}

export default function InterviewMenu({ onCSVDownload, onRegenerateScores, isProcessing }: IProps) {
    const { t } = useTranslation('common');
  const { isOpen, onClose, onOpen } = useDisclosure({
    id: 'regenerate-score-alert',
  });

  const onRegenerateScoresHandler = () => {
    onRegenerateScores();
    onClose();
  };

  return (
    <>
      <Menu placement="bottom-end">
        <MenuButton as={IconButton} aria-label={t('common:moreActions2')} icon={<FontAwesomeIcon icon={regular('cog')} />} />

        <MenuList>
          <MenuItem onClick={onCSVDownload}>{t('common:downloadCsv')}</MenuItem>
          <MenuItem onClick={onOpen} isDisabled={isProcessing}>
            {t('common:regenerateScores')}
                                </MenuItem>
          <MenuItem>
            {' '}
            <Link to="identity-details"> {t('common:viewIdentityDetails')} </Link>{' '}
          </MenuItem>
        </MenuList>
      </Menu>

      <ConfirmationModal
        id="regenerate-score-alert"
        isOpen={isOpen}
        titleText="Regenerate scores"
        descriptionText="This will generate a new set of scores. These scores may differ from what has previously been generated. Any custom changes made will be overwritten. Are you sure you want to continue?"
        confirmationButtonText="Regenerate"
        onClickSuccess={onRegenerateScoresHandler}
        onClose={onClose}
      />
    </>
  );
}
